/* GiftInOne Editor 2.15.8: one template field with order-safe format discovery.
 * Unassigned products retain the shared-profile or original adapter contracts.
 */
(function (window, document) {
  'use strict';
  if (window.GIOEditorV2TemplateAdapter) return;
  var state = { fileRecords: Object.create(null), filePending: Object.create(null), fileFailures: Object.create(null), session: 0, native: null, bypass: false, fallbackReady: false, fallbackPending: null, shared: null, runtime: null, profile: null, profileHash: '', pending: null, scene: null, proof: null, adapter: null, main: null, manualAdapter: null, manualScene: null, manualSticky: false, manualFailure: null };
  function config() { return window.GIOEditorV2Config || {}; }
  function direct() { return !!config().fileTemplateEnabled; }
  function unified() { return !!config().unifiedTemplateEnabled; }
  function usesLayered() { return !!(config().compositionEnabled || config().templateManualFallback); }
  function universal() { return !direct() && !!config().universalEnabled; }
  function fileCore() {
    if (!window.GIOFileTemplateCore) fail('The template tools could not load. Refresh this page and try again.');
    return window.GIOFileTemplateCore;
  }
  function configured() { return config().templateEnabled == null ? !!String(config().templateProfileKey || '').trim() : !!config().templateEnabled; }
  function sharedCore() {
    if (!window.GIOUniversalCore) fail('The shared template tools could not load. Refresh this page and try again.');
    return window.GIOUniversalCore;
  }
  function currentContext(chosenVariant) {
    var original = config().productContext;
    if (!original || original.schema !== 'gio-product-context-v1') fail('The product information could not be loaded. Refresh this page.');
    var selected = availability(), variant = chosenVariant || (config().variants || []).find(function (v) { return String(v.id) === String(selected.variantId); });
    if (!variant) fail('Choose your product options before designing your gift.');
    var context = Object.assign({}, original, { variant: { id: String(variant.id), sku: String(variant.sku || ''), options: variant.options.slice(), available: !!variant.available } });
    context.directTemplate = { product: original.directTemplate && original.directTemplate.product || {}, variant: variant.directTemplate || {} };
    context.directComposition = { product: original.directComposition && original.directComposition.product || {}, variant: variant.directComposition || {} };
    if (unified() && window.GIOUnifiedTemplateRouter) context = window.GIOUnifiedTemplateRouter.assignment(context).context;
    // Bind preview jobs to the active theme even when a Liquid integration
    // omits theme.id. Only numeric IDs can become a production query argument.
    var candidates = [original.themeId, window.Shopify && window.Shopify.theme && window.Shopify.theme.id];
    try { candidates.push(new URL(window.location.href).searchParams.get('preview_theme_id')); } catch (_) {}
    context.themeId = '';
    for (var i = 0; i < candidates.length; i += 1) {
      var themeId = String(candidates[i] || '');
      if (/^[1-9][0-9]{0,19}$/.test(themeId)) { context.themeId = themeId; break; }
    }
    return context;
  }
  async function ensureNativeFallback() {
    if (state.fallbackReady) return;
    if (state.fallbackPending) return state.fallbackPending;
    state.fallbackPending = (async function () {
      if (state.native && typeof state.native.prepareNativeFallback === 'function') await state.native.prepareNativeFallback();
      state.fallbackReady = true;
    }()).then(function () { state.fallbackPending = null; }, function (error) { state.fallbackPending = null; throw error; });
    return state.fallbackPending;
  }
  async function restoreNative(reason) {
    state.bypass = true; state.profile = null; state.runtime = null; state.proof = null;
    config().universalEnabled = false; config().templateEnabled = false;
    config().universalBypassReason = reason || 'This product keeps its existing print layout.';
    if (state.main) {
      if (state.main.classList) state.main.classList.remove('gio-editor-v2-template');
      var wrap = state.main.querySelector('.text-item-wrap'); if (wrap) wrap.hidden = false;
      state.main.querySelectorAll('[data-gio-template-bound]').forEach(function (row) { row.removeAttribute('data-gio-template-bound'); row.hidden = false; });
    }
    await ensureNativeFallback();
    return null;
  }
  function resolveShared(selection) {
    if (!state.shared) fail('Your product template is still loading. Please try again.');
    var context = currentContext(), runtime = sharedCore().resolve(state.shared, context, selection || {});
    if (!selection && state.scene) {
      var desired = {};
      if (runtime.photoCountMode === 'free' && runtime.allowedPhotoCounts.indexOf(Number(state.scene.photoCount)) !== -1) desired.photoCount = Number(state.scene.photoCount);
      if (Object.keys(desired).length) runtime = sharedCore().resolve(state.shared, context, desired);
      if (runtime.profile.templateIds.indexOf(state.scene.templateId) !== -1) desired.templateId = state.scene.templateId;
      if (Object.keys(desired).length) runtime = sharedCore().resolve(state.shared, context, desired);
    }
    state.runtime = runtime; state.profile = runtime.profile;
    return runtime;
  }
  function fail(message) { throw new Error(message); }
  function core() {
    if (!window.GIOTemplateCore) fail('The template tools could not load. Refresh this page and try again.');
    return window.GIOTemplateCore;
  }
  function directBinding(context) {
    var binding = fileCore().binding(context || currentContext());
    if (!binding.configured) fail('A product option is missing its template or print dimensions. Please contact us.');
    return binding;
  }
  function resolveDirect() {
    var context = currentContext(), binding = directBinding(context), record = state.fileRecords[binding.key];
    if (!record) fail('Your product template is still loading. Please try again.');
    var runtime = fileCore().resolve(record.file, context);
    state.runtime = runtime; state.profile = runtime.profile; state.profileHash = record.hash;
    return runtime;
  }
  function profileKey() { if (direct()) return directBinding().key; return universal() ? sharedCore().configKey(String(config().universalConfigKey || '').trim()) : core().profileKey(String(config().templateProfileKey || '').trim(), String(config().productId)); }
  function availability() {
    return window.GIOEditorV2Availability ? window.GIOEditorV2Availability.read(config(), state.main, document.getElementById('nextButton')) : { available: false, variantId: '' };
  }
  function resolved(selection) {
    if (direct()) return resolveDirect().resolved;
    if (universal()) return resolveShared(selection).resolved;
    if (!state.profile) fail('Your product template is still loading. Please try again.');
    var current = availability();
    if (!current.variantId) fail('Choose your product options before designing your gift.');
    return core().resolve(state.profile, String(current.variantId));
  }
  function signature() {
    if (!configured()) return '';
    if (direct()) {
      var ctx = currentContext(), binding = directBinding(ctx), record = state.fileRecords[binding.key];
      return ['file-template', binding.key, String(ctx.productId), String(ctx.variant.id), binding.width, binding.height, record && record.hash || 'pending', state.session].join('|');
    }
    return [universal() ? 'universal' : 'template', String(universal() ? config().universalConfigKey : config().templateProfileKey), state.profile && state.profile.version || 'pending',
      String(config().productId), String(availability().variantId || ''), state.profileHash].join('|');
  }
  function buildUrl(key) {
    var auth = window.GiftInOneAwsUploadAuth;
    if (!auth || typeof auth.getUploadConfig !== 'function') fail('The upload service could not load. Refresh this page and try again.');
    var upload = auth.getUploadConfig(), base = upload.staticBaseUrl;
    if (!base && /^[a-z0-9.-]+$/.test(upload.bucketName || '') && /^[a-z0-9-]+$/.test(upload.region || '')) base = 'https://' + upload.bucketName + '.s3.' + upload.region + '.amazonaws.com';
    var url;
    try { url = new URL(String(base || '').replace(/\/$/, '') + '/' + key); } catch (_) { fail('The template source is not configured. Please contact us.'); }
    if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash) fail('The template source is not configured. Please contact us.');
    return url.href;
  }
  function directUrl(key) {
    var auth = window.GiftInOneAwsUploadAuth;
    if (!auth || typeof auth.getUploadConfig !== 'function') fail('The upload service could not load. Refresh this page and try again.');
    var upload = auth.getUploadConfig(), base;
    // The bucket remains private. Mutable templates are read through the same
    // public CDN as other artwork; their CDN behavior must disable caching.
    // Never fall back to anonymous S3 reads or no-cors opaque responses.
    try { base = new URL(String(upload.staticBaseUrl || '')); } catch (_) { fail('The template source is not configured. Please contact us.'); }
    if (base.origin !== 'https://static.giftinone.com' || base.pathname !== '/' || base.username || base.password || base.search || base.hash) fail('The template source is not configured. Please contact us.');
    fileCore().keySlug(key);
    return base.origin + '/' + key;
  }
  function directSelection() { return JSON.stringify([state.session, currentContext()]); }
  // A raw-photo order needs Shopify identity, never merchant print geometry.
  // This separate context is only used after a configuration/resource failure.
  function manualContext() {
    var cfg=config(), original=cfg.productContext && typeof cfg.productContext==='object' ? cfg.productContext : {}, stock=availability();
    var variants=Array.isArray(cfg.variants)?cfg.variants:[], selected=variants.find(function(v){return v && String(v.id)===String(stock.variantId);});
    if(!selected || !stock.available || stock.pending) fail(stock.message || 'Choose an available product option.');
    var context=Object.assign({},original,{schema:'gio-product-context-v1',productId:String(cfg.productId || original.productId || ''),
      variant:{id:String(selected.id),sku:String(selected.sku || ''),options:Array.isArray(selected.options)?selected.options.slice():[],available:true},
      directTemplate:{product:original.directTemplate && original.directTemplate.product || {},variant:selected.directTemplate || {}},
      directComposition:{product:original.directComposition && original.directComposition.product || {},variant:selected.directComposition || {}}});
    if(unified() && window.GIOUnifiedTemplateRouter){try{context=window.GIOUnifiedTemplateRouter.assignment(context).context;}catch(_){} }
    return context;
  }
  function hasDetails(scene) {
    if (!scene) return false;
    var photos = (scene.photos || []).concat(Object.keys(scene.retainedPhotos || {}).map(function (id) { return scene.retainedPhotos[id]; }));
    var texts = (Array.isArray(scene.texts) ? scene.texts : []).concat(scene.freeTexts || [], Object.keys(scene.retainedTexts || {}).map(function (id) { return scene.retainedTexts[id]; }));
    return photos.some(function (photo) { return !!(photo && photo.file && photo.file.size); }) || texts.some(function (item) { return !!String(item && (item.text || item.value) || '').trim(); }) || !!String(scene.manualNotes || '').trim();
  }
  function manualMetadata(error) {
    var context = manualContext(), assignment = context.directTemplate || {}, product = assignment.product || {}, variant = assignment.variant || {};
    var id = (String(variant.template || '').trim() || String(product.template || '').trim()).slice(0, 80), key = '';
    try { key = fileCore().templateKey(id); } catch (_) {}
    var ownDimensions = variant.width != null && String(variant.width).trim() !== '' || variant.height != null && String(variant.height).trim() !== '';
    var source = ownDimensions ? variant : product;
    function dimension(value) { var number = Number(value); return Number.isFinite(number) && number > 0 && number <= 100000 ? number : null; }
    var metadata = { templateId: id, templateKey: key, width: dimension(source.width), height: dimension(source.height),
      reasonCode: 'TEMPLATE_UNAVAILABLE', errorCode: String(error && error.code || 'TEMPLATE_READ_FAILED').replace(/[^A-Z0-9_]/g, '').slice(0, 80),
      reason: 'Upload your original photos and instructions. We will check the details before printing.', basicUpload: true };
    if (state.manualSticky && state.manualFailure && (metadata.templateId !== state.manualFailure.templateId || metadata.width !== state.manualFailure.width || metadata.height !== state.manualFailure.height)) metadata.originalFailure = state.manualFailure;
    return metadata;
  }
  function manualAdapter() {
    if (!state.manualAdapter) {
      if (!window.GIOEditorV2LayeredAdapter || !state.native) fail('The personalization tools could not load. Refresh this page and try again.');
      state.manualAdapter = window.GIOEditorV2LayeredAdapter.wrap(state.native);
    }
    return state.manualAdapter;
  }
  function clearTemplateProperties() {
    var form = state.main && state.main.querySelector('#appendForm');
    if (form && form.querySelectorAll) form.querySelectorAll('[data-gio-template-text]').forEach(function (input) { input.remove(); });
  }
  async function activateManual(error) {
    var previousFlag = config().templateManualFallback;
    var previous = previousFlag ? state.manualScene || state.scene : state.scene || state.manualScene;
    if (hasDetails(previous)) state.manualSticky = true;
    var metadata = manualMetadata(error);
    if (!state.manualFailure) state.manualFailure = Object.assign({}, metadata);
    if (unified()) { config().compositionEnabled = false; config().unifiedTemplateResolved = null; }
    // A valid template is still useful for editing even when its production
    // dimensions are missing. Keep those viewBox pixels preview-only: the
    // layered/manual contract exports output:null and never submits an HD job.
    var previousPreview = config().templatePreviewFallback;
    config().templatePreviewFallback = null;
    try {
      var known = state.fileRecords[metadata.templateKey];
      var previewContext = manualContext();
      var previousMatches = previousPreview && previousPreview.templateId === metadata.templateId && previousPreview.productId === String(previewContext.productId) && previousPreview.variantId === String(previewContext.variant.id);
      if (known && known.file || previousMatches) {
        var preview = known && known.file ? window.GIOEditorV2LayeredAdapter.previewFallback(known.file, previewContext) : previousPreview.runtime;
        metadata.basicUpload = false; metadata.previewOnly = true; metadata.reasonCode = 'PRINT_CONFIGURATION_REVIEW';
        metadata.reason = 'Personalize your design. We will check the print setup before printing.';
        config().templatePreviewFallback = { runtime: preview, templateId: metadata.templateId, productId: String(manualContext().productId), variantId: String(manualContext().variant.id) };
      }
    } catch (_) { /* Unusable geometry keeps the original-photo upload path. */ }
    config().templateManualFallback = metadata; state.proof = null; clearTemplateProperties();
    var adapter = manualAdapter();
    state.manualScene = previous;
    if (JSON.stringify(previousFlag || null) !== JSON.stringify(metadata)) adapter.setDesignDraft('0', previous);
    else adapter.syncTemplateScene(previous);
    return window.GIOEditorV2LayeredAdapter.loadProfile();
  }
  async function loadDirectSafely() {
    var session = state.session, selection;
    try {
      selection = directSelection();
      if (state.manualSticky || state.fileFailures[selection]) return activateManual(state.fileFailures[selection]);
      var profile = unified() ? await loadUnifiedProfile(session, selection) : await loadDirectProfile();
      if (session !== state.session) fail('Your editing session changed. Reopen your design.');
      if (selection !== directSelection()) return loadDirectSafely();
      config().templateManualFallback = false; config().templatePreviewFallback = null;
      state.manualScene = null; state.manualFailure = null;
      return profile;
    } catch (error) {
      // A late response must not force a newly selected variant/session into
      // manual preparation. Its own request decides its state.
      if (session !== state.session) throw error;
      if (selection) {
        try { if (selection !== directSelection()) return loadDirectSafely(); } catch (_) {}
        state.fileFailures[selection] = error;
      }
      return activateManual(error);
    }
  }
  async function loadUnifiedProfile(session, selection) {
    if (!window.GIOUnifiedTemplateRouter) fail('The template tools are unavailable.');
    if (!state.router) state.router = window.GIOUnifiedTemplateRouter.create();
    var selected = await state.router.resolve(currentContext());
    if (session !== state.session) fail('Your editing session changed. Reopen your design.');
    if (selection !== directSelection()) return loadDirectSafely();
    config().templateManualFallback = false;
    if (selected.kind === 'composition') {
      var context = currentContext();
      config().unifiedTemplateResolved = { id: selected.id, key: selected.key, envelope: selected.envelope, productId: String(context.productId), variantId: String(context.variant.id) };
      config().compositionEnabled = true; state.proof = null; clearTemplateProperties();
      manualAdapter().syncTemplateScene(state.scene || state.manualScene);
      return window.GIOEditorV2LayeredAdapter.loadProfile();
    }
    config().compositionEnabled = false; config().unifiedTemplateResolved = null;
    state.fileRecords[selected.key] = { file: selected.file, hash: fileCore().templateHash(selected.file) };
    return loadDirectProfile();
  }
  async function loadDirectProfile() {
    // A sibling variant may intentionally retain its old editor or contain an
    // unfinished assignment. Only this selection may enable or block a design.
    var context = currentContext(), assignment = context.directTemplate || {}, product = assignment.product || {}, variant = assignment.variant || {};
    var templateId = (String(variant.template || '').trim() || String(product.template || '').trim());
    // Discover the file independently of HD settings, so a missing width or
    // malformed height cannot erase an otherwise usable customer editor.
    var binding = { templateId: templateId, key: fileCore().templateKey(templateId) };
    var records = state.fileRecords, pending = state.filePending, session = state.session;
    if (!records[binding.key]) {
      if (!pending[binding.key]) {
        pending[binding.key] = (async function () {
          try {
            if (!window.GIOPublicResource) fail('The template loading tools are unavailable.');
            var response = await window.GIOPublicResource.read(directUrl(binding.key), { maximum: 2097152 });
            if (!response.ok) { var unavailable = new Error('The product template is unavailable.'); unavailable.code = 'TEMPLATE_HTTP_' + response.status; throw unavailable; }
            var text = new TextDecoder().decode(response.bytes);
            if (text.length > 2097152) fail('This product template is too large. Please contact us.');
            var file;
            try { file = JSON.parse(text); } catch (_) { fail('This product template is not configured correctly. Please contact us.'); }
            file = fileCore().validateTemplate(file);
            if (file.id !== binding.templateId) fail('The template file name does not match its design. Please contact us.');
            if (!window.crypto || !window.crypto.subtle) fail('Please use a secure browser connection to load this template.');
            var digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(file)));
            var hash = Array.prototype.map.call(new Uint8Array(digest), function (n) { return n.toString(16).padStart(2, '0'); }).join('');
            if (session !== state.session) fail('Your editing session changed. Reopen your design.');
            records[binding.key] = { file: file, hash: hash };
          } catch (error) {
            if (error && error.name === 'AbortError') fail('The product template took too long to load. Check your connection and retry.');
            throw error;
          }
        }()).finally(function () { delete pending[binding.key]; });
      }
      await pending[binding.key];
    }
    if (session !== state.session) fail('Your editing session changed. Reopen your design.');
    // The selected variant may have changed while the JSON was downloading.
    // Resolve its own dimensions and file, never return the completed old one.
    var latest = currentContext().directTemplate || {};
    if (fileCore().templateKey((String(latest.variant && latest.variant.template || '').trim() || String(latest.product && latest.product.template || '').trim())) !== binding.key) return loadDirectProfile();
    return resolveDirect().profile;
  }
  function beginSession() {
    if (!direct()) return;
    state.session += 1; state.fileRecords = Object.create(null); state.filePending = Object.create(null); state.fileFailures = Object.create(null); state.profile = null; state.runtime = null; state.profileHash = ''; state.proof = null; state.pending = null;
    state.router = null;
    if (unified()) { config().compositionEnabled = false; config().unifiedTemplateResolved = null; }
    // Retain a manual draft across closing/reopening the editor. Resetting it
    // implicitly would lose customer notes/files that have no template slot.
    if (!state.manualSticky) { config().templateManualFallback = false; state.manualScene = null; state.manualFailure = null; }
    if (state.manualAdapter) window.GIOEditorV2LayeredAdapter.beginSession();
  }
  async function loadProfile() {
    var session=state.session, variantId=String(availability().variantId || '');
    try { return await loadConfiguredProfile(); }
    catch(error) {
      var stock=availability();
      if(session!==state.session || String(stock.variantId || '')!==variantId || !stock.available || stock.pending) throw error;
      return activateManual(error);
    }
  }
  async function loadConfiguredProfile() {
    if (config().templateManualFallback && !direct()) return window.GIOEditorV2LayeredAdapter.loadProfile();
    if (direct()) return loadDirectSafely();
    if (state.bypass) { await ensureNativeFallback(); return null; }
    if (universal() && state.shared) return resolveShared().profile;
    if (!universal() && state.profile) return state.profile;
    if (state.pending) return state.pending;
    state.pending = (async function () {
      var key = profileKey(), controller = new AbortController();
      var timer = window.setTimeout(function () { controller.abort(); }, 15000);
      try {
        if (!window.GIOPublicResource) fail('The template loading tools are unavailable.');
        var response = await window.GIOPublicResource.read(buildUrl(key), { maximum: 2097152 });
        if (!response.ok) fail('This product template could not be loaded. Please retry, or contact us if the problem continues.');
        var text = new TextDecoder().decode(response.bytes);
        if (text.length > 2097152) fail('This product template is too large. Please contact us.');
        var profile;
        try { profile = JSON.parse(text); } catch (_) { fail('This product template is not configured correctly. Please contact us.'); }
        if (universal()) {
          profile = sharedCore().validateConfig(profile);
          if (key !== 'backimg/gio-templates/universal/' + String(profile.version) + '.json') fail('The shared template version does not match its configuration. Please contact us.');
        } else {
          profile = core().validateProfile(profile, String(config().productId));
          if (key !== 'backimg/gio-templates/profiles/' + String(config().productId) + '/' + String(profile.version) + '.json') fail('This product template version does not match its configuration. Please contact us.');
          (config().variants || []).forEach(function (variant) {
            if (!Object.prototype.hasOwnProperty.call(profile.variants, String(variant.id))) fail('A product option is missing its template. Please contact us.');
          });
        }
        if (!window.crypto || !window.crypto.subtle) fail('Please use a secure browser connection to load this template.');
        var digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(profile)));
        state.profileHash = Array.prototype.map.call(new Uint8Array(digest), function (n) { return n.toString(16).padStart(2, '0'); }).join('');
        if (universal()) {
          // Decide the entire product before its first design. An auto-only,
          // unsupported print surface keeps all variants in the native engine.
          // Invalid explicit merchant mappings still throw from the resolver.
          var fallback = null;
          (config().variants || []).forEach(function (variant) {
            var candidate = sharedCore().resolve(profile, currentContext(variant), {});
            if (candidate.bypass) fallback = candidate;
          });
          // A failed all-variant validation must run again on Retry. Never
          // cache the shared profile before every explicit assignment validates.
          state.shared = profile;
          if (fallback) return await restoreNative(fallback.reason);
          return resolveShared().profile;
        }
        state.profile = profile; return profile;
      } catch (error) {
        if (error && error.name === 'AbortError') fail('The product template took too long to load. Check your connection and retry.');
        throw error;
      } finally { window.clearTimeout(timer); }
    }()).then(function (profile) { state.pending = null; return profile; }, function (error) { state.pending = null; throw error; });
    return state.pending;
  }
  function textValues() {
    var texts = state.scene && state.scene.texts || [];
    var values = Object.create(null);
    if (Array.isArray(texts)) texts.forEach(function (item) { if (item) values[String(item.fieldId || item.id || '')] = String(item.value == null ? item.text || '' : item.value); });
    else Object.keys(texts).forEach(function (id) { var item = texts[id]; values[id] = String(item && typeof item === 'object' ? item.value == null ? item.text || '' : item.value : item == null ? '' : item); });
    return values;
  }
  function bindNativeText() {
    if (state.bypass || !state.profile || !state.main) return;
    var fields = Array.prototype.slice.call(state.main.querySelectorAll('.text-item-wrap input[type="text"], .text-item-wrap textarea'));
    var form = state.main.querySelector('#appendForm'), values = textValues();
    if (direct()) {
      // Template-owned text replaces old tag-defined text requirements. Keep
      // native DOM in place for compatibility, but never submit stale fields.
      fields.forEach(function (input) { input.disabled = true; });
      var directWrap = state.main.querySelector('.text-item-wrap'); if (directWrap) directWrap.hidden = true;
      if (!form) return;
      if (typeof form.querySelectorAll === 'function') form.querySelectorAll('[data-gio-template-text]').forEach(function (input) {
        if (!state.profile.textFields.some(function (field) { return field.id === input.getAttribute('data-gio-template-text'); })) input.remove();
      });
      state.profile.textFields.forEach(function (field) {
        var input = form.querySelector('[data-gio-template-text="' + field.id + '"]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.setAttribute('data-gio-template-text', field.id); form.appendChild(input); }
        input.name = 'properties[' + field.label + ']'; input.disabled = false;
        input.value = Object.prototype.hasOwnProperty.call(values, field.id) ? values[field.id] : String(field.default || '');
      });
      return;
    }
    // Assigned templates can have different numbers/IDs of text fields. Clear
    // prior row bindings and remove generated fields that no longer print.
    state.main.querySelectorAll('[data-gio-template-bound]').forEach(function (row) { row.removeAttribute('data-gio-template-bound'); row.hidden = false; });
    if (form && typeof form.querySelectorAll === 'function') form.querySelectorAll('[data-gio-template-text]').forEach(function (input) {
      if (!state.profile.textFields.some(function (field) { return field.id === input.getAttribute('data-gio-template-text'); })) input.remove();
    });
    state.profile.textFields.forEach(function (field, index) {
      var input = fields[index] || form && form.querySelector('[data-gio-template-text="' + field.id + '"]');
      if (!input && form) {
        input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + field.label + ']';
        input.setAttribute('data-gio-template-text', field.id); form.appendChild(input);
      }
      if (input && typeof input.closest === 'function') {
        var row = input.closest('.text-container'); if (row) { row.setAttribute('data-gio-template-bound', field.id); row.hidden = true; }
      }
      if (input) { input.value = Object.prototype.hasOwnProperty.call(values, field.id) ? values[field.id] : String(field.default || ''); input.style.border = ''; }
    });
    var wrap = state.main.querySelector('.text-item-wrap');
    if (wrap) wrap.hidden = !universal() || fields.length <= state.profile.textFields.length;
  }
  function validateText() {
    if (!configured()) return { valid: true };
    try {
      if (!state.profile || !state.scene) fail('Please complete your template design.');
      var values = textValues();
      state.profile.textFields.forEach(function (field) {
        var value = Object.prototype.hasOwnProperty.call(values, field.id) ? values[field.id] : String(field.default || '');
        if (field.required && !value.trim()) fail('Please enter ' + field.label + '.');
        if (Array.from(value).length > field.maxLength) fail(field.label + ' must be ' + field.maxLength + ' characters or fewer.');
      });
      bindNativeText();
      // Universal templates bind their printable fields, but any additional
      // legacy order-personalization inputs remain visible and required.
      if (universal() && state.main) {
        var extras = Array.prototype.slice.call(state.main.querySelectorAll('.text-item-wrap input[type="text"], .text-item-wrap textarea')).slice(state.profile.textFields.length);
        extras.forEach(function (input) {
          var value = String(input.value || ''), limit = Number(input.maxLength);
          if (!value.trim()) fail('Please complete the additional personalization details.');
          if (limit > 0 && Array.from(value).length > limit) fail('An additional personalization detail is too long.');
        });
      }
      return { valid: true };
    } catch (error) { return { valid: false, message: error.message }; }
  }
  function validateForCart(variantId) {
    if (!configured()) return { valid: true };
    try {
      var current = resolved(), proof = state.proof, stock = availability();
      if (!stock.available || stock.pending) fail(stock.message || 'Choose an available product option.');
      if (variantId != null && String(variantId) !== String(current.variantId)) fail('Your product options changed. Please review the design again.');
      if (!proof || proof.signature !== signature() || String(proof.variantId) !== String(current.variantId)) fail('Please review and save your current template design before adding to cart.');
      var texts = validateText(); if (!texts.valid) fail(texts.message);
      var form = state.main && state.main.querySelector('#appendForm');
      var preview = document.getElementById('crop_picture'), hd = document.getElementById('hd_picture');
      var manifest = form && form.querySelector('[name="properties[_DesignManifest0]"]');
      if (!preview || preview.value !== proof.previewUrl || !hd || hd.value !== proof.hdUrl || !manifest || manifest.value !== proof.manifestUrl) fail('Your saved design is incomplete. Please review it again.');
      for (var i = 0; i < proof.originalUrls.length; i += 1) {
        var source = form.querySelector('[name="properties[_DesignSource0_' + i + ']"]');
        if (!source || source.value !== proof.originalUrls[i]) fail('A source photo is missing. Please save your design again.');
      }
      return { valid: true };
    } catch (error) { return { valid: false, message: error.message }; }
  }
  function wrap(nativeAdapter) {
    if (!configured() || nativeAdapter.templateAdapter) return nativeAdapter;
    var adapter = Object.create(nativeAdapter);
    adapter.templateAdapter = true; state.adapter = adapter; state.native = nativeAdapter;
    state.main = nativeAdapter.mainModal && (nativeAdapter.mainModal.modal || nativeAdapter.mainModal);
    adapter.getDesignAreas = function () {
      if (usesLayered()) return manualAdapter().getDesignAreas();
      if (state.bypass) return nativeAdapter.getDesignAreas.call(nativeAdapter);
      var proof = state.proof, valid = false;
      // Keep a printable-area shell if the newly selected binding is invalid,
      // so getDesignContext can show its precise validation error.
      try { valid = !!(proof && proof.signature === signature()); } catch (_) {}
      return [{ index: '0', areaId: unified() ? 'unified-template:0' : 'template:0', label: 'Your finished gift', pending: false,
        preview: valid ? proof.previewUrl : '', hasSource: !!state.scene, confirmed: !!valid }];
    };
    adapter.getDesignContext = async function (index) {
      await loadProfile();
      if (usesLayered()) return manualAdapter().getDesignContext(index);
      if (state.bypass) return nativeAdapter.getDesignContext.call(nativeAdapter, index);
      var current = resolved(), info = { profileKey: profileKey(), profileHash: state.profileHash, profile: state.profile, resolved: current, unifiedTemplate: unified() };
      if (direct()) Object.assign(info, state.runtime, { fileTemplate: true, templateKey: profileKey(), templateHash: state.profileHash, templateFile: state.fileRecords[profileKey()].file, context: currentContext(), profileKey: profileKey(), profileHash: state.profileHash });
      if (universal()) Object.assign(info, state.runtime, { universal: true, configKey: profileKey(), configHash: state.profileHash, config: state.shared, context: currentContext(), profileKey: profileKey(), profileHash: state.profileHash });
      return { title: state.profile.title || 'Your finished gift', areaId: unified() ? 'unified-template:0' : 'template:0',
        geometryKey: unified() ? 'unified-template-product:' + String(config().productId) : direct() ? 'file-template-product:' + String(config().productId) : 'template:' + profileKey(), signature: signature(), aspectRatio: current.layoutAspect || current.width / current.height,
        width: current.width, height: current.height, scene: state.scene, sourceFile: null,
        template: info };
    };
    adapter.setDesignDraft = function (index, scene) {
      if (usesLayered()) { state.scene = scene; state.manualScene = scene; if (config().templateManualFallback && hasDetails(scene)) state.manualSticky = true; return manualAdapter().setDesignDraft(index, scene); }
      if (state.bypass) return nativeAdapter.setDesignDraft.call(nativeAdapter, index, scene);
      state.scene = scene; state.proof = null; bindNativeText();
      return nativeAdapter.setDesignDraft.call(nativeAdapter, '0', scene);
    };
    // Infrastructure failure only: preserve File objects and every customer
    // field, then require review of the existing manual-order fallback.
    adapter.recoverUploadFailure = async function (error) {
      if (!direct() || usesLayered() || !error || error.code !== 'TEMPLATE_UPLOAD_UNAVAILABLE') return false;
      await activateManual(error);
      return true;
    };
    adapter.recoverPreviewFailure = async function (error) {
      if (!direct() || usesLayered() || !error || error.code !== 'TEMPLATE_PREVIEW_UNAVAILABLE') return false;
      await activateManual(error);
      return true;
    };
    adapter.beginTemplateSession = beginSession;
    adapter.refreshTemplateBindings = function () { if (usesLayered()) return manualAdapter().refreshTemplateBindings(); return bindNativeText(); };
    adapter.syncTemplateScene = function (scene) { if (usesLayered()) { state.scene = scene; state.manualScene = scene; if (config().templateManualFallback && hasDetails(scene)) state.manualSticky = true; return manualAdapter().syncTemplateScene(scene); } if (state.bypass) return; state.scene = scene; bindNativeText(); };
    adapter.validateCartDetails = function () {
      if (usesLayered()) return manualAdapter().validateCartDetails();
      if (state.bypass) return nativeAdapter.validateCartDetails.call(nativeAdapter);
      var text = validateText(); if (!text.valid) return text;
      return nativeAdapter.validateCartDetails.call(adapter);
    };
    adapter.applyDesignResult = async function (index, result) {
      if (usesLayered()) { var applied = await manualAdapter().applyDesignResult(index, result); state.scene = result.scene || state.scene; state.manualScene = state.scene; if (config().templateManualFallback && hasDetails(state.manualScene)) state.manualSticky = true; return applied; }
      if (state.bypass) return nativeAdapter.applyDesignResult.call(nativeAdapter, index, result);
      var current = resolved(universal() && result ? { templateId: result.templateId, photoCount: result.photoCount } : undefined);
      var wrongContract = !result || (direct()
        ? result.fileTemplate !== true || result.schema !== 'gio-file-design-v1' || result.templateKey !== profileKey() || result.templateHash !== state.profileHash
        : result.profileKey !== profileKey() || result.profileHash !== state.profileHash || result.profileVersion !== state.profile.version || result.templateVersion !== state.profile.templateVersion);
      if (!result || result.template !== true || result.signature !== signature() || wrongContract
          || String(result.productId) !== String(config().productId) || String(result.variantId) !== String(current.variantId)
          || state.profile.templateIds.indexOf(result.templateId) === -1
          || !result.previewUrl || !result.hdUrl || !result.manifestUrl || !Array.isArray(result.originalUrls)
          || result.photoCount !== current.photoCount || result.outputWidth !== current.width || result.outputHeight !== current.height
          || result.originalUrls.length !== current.photoCount || result.originalUrls.some(function (url) { return !url; })) {
        fail('The saved template does not match your product options. Please review it and try again.');
      }
      state.scene = result.scene || state.scene; bindNativeText();
      if (typeof nativeAdapter.applyTemplateResult !== 'function') fail('The template order tools could not load. Please refresh this page.');
      await nativeAdapter.applyTemplateResult(result, { signature: signature(), geometryKey: 'template:' + profileKey(), aspectRatio: current.layoutAspect || current.width / current.height, areaId: 'template:0', title: state.profile.title });
      state.proof = result; return true;
    };
    return adapter;
  }
  var originalApi = { isConfigured: configured, signature: signature, wrap: wrap,
    validateForCart: validateForCart, validateText: validateText, beginSession: beginSession, loadProfile: loadProfile, bindNativeText: bindNativeText };
  window.GIOEditorV2TemplateAdapter = { wrapSingle: wrap, useResolver: function (router) { if (router && typeof router.resolve === 'function') state.router = router; } };
  Object.keys(originalApi).forEach(function (name) {
    window.GIOEditorV2TemplateAdapter[name] = function () {
      var multi = window.GIOEditorV2MultiSurfaceAdapter;
      if (multi && multi.isActive() && typeof multi[name] === 'function') return multi[name].apply(multi, arguments);
      // Direct-template wrappers must retain control of loading/recovery and
      // draft retention, even after entering the shared manual order flow.
      var directControl = direct() && (name === 'wrap' || name === 'beginSession' || name === 'loadProfile');
      var layered = !directControl && (config().compositionEnabled || config().templateManualFallback) && window.GIOEditorV2LayeredAdapter;
      return (layered && typeof layered[name] === 'function' ? layered[name] : originalApi[name]).apply(layered || originalApi, arguments);
    };
  });
}(window, document));
